import React, { Component } from 'react';

class Header extends Component {
  render() {
    // Optional: Destructure props if you want to pass dynamic user initials or logout handlers later
    const { userInitials = "HK" } = this.props;

    return (
      <header className="w-full flex justify-between items-center px-8 py-6 md:px-12 bg-transparent">
        {/* Logo Brand */}
        <div className="flex items-center space-x-2 select-none">
          <img src="/img/TalentPlusStrengths_logo.svg" alt="TalentPlusStrengths_logo" className="bg-cover cursor-pointer md:w-36 w-28" />
        </div>

        {/* User Profile Avatar */}
        <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-medium text-sm shadow-sm cursor-pointer hover:bg-blue-700 transition duration-150 active:scale-95">
          {userInitials}
        </div>
      </header>
    );
  }
}

export default Header;